<template>
  <div class="purchase">
    <div class="section-title">{{$t('cdnOrderList.region')}}</div>

    <!-- 资源类型部分 -->
    <div><span class="intro-text">{{$t('resourceList.name')}}：</span></div>

    <el-empty v-if="resourceData.length === 0" :image-size="50" description="暂无可用资源类型"></el-empty>
<!--    <div v-if="resourceData.length === 0" class="no-data">暂无可用资源类型</div>-->
    <div v-else class="radio-group-container">
      <el-radio
          v-for="(item) in resourceData"
          :key="item.id"
          v-model="purchaseFrom.radioResource"
          :label="item.id.toString()"
          border
          class="radio-item"
          @change="handleResourceChange"
      >
        {{ item.name }}
      </el-radio>
    </div>
    <span class="intro-text">{{ $t('accelerationList.name') }}：</span>
    <div class="radio-group-container" v-if="filteredAccelerationData.length > 0">
      <el-radio
          v-for="(item) in filteredAccelerationData"
          :key="item.id"
          v-model="purchaseFrom.radioAcceleration"
          :label="item.id.toString()"
          border
          class="radio-item"
          @change="handleAccelerationChange"
      >
        {{ item.name }}
      </el-radio>
    </div>
<!--    <div v-else class="no-data">暂无可用的加速区域</div>-->
    <el-empty v-else :image-size="50" description="暂无可用的加速区域"></el-empty>
    <div class="section-title">流量</div>
    <div><span class="intro-text">{{$t('trafficList.size')}}：</span></div>
    <div class="radio-group-container" v-if="filteredTrafficData.length > 0">
      <el-radio
          v-for="(item) in filteredTrafficData"
          :key="item.id"
          v-model="purchaseFrom.radioTraffic"
          :label="item.id.toString()"
          border
          class="radio-item"
      >
        {{ item.size }}
      </el-radio>
    </div>
<!--    <div v-else class="no-data">暂无可用的流量包</div>-->
    <el-empty v-else :image-size="50" description="暂无可用的流量包"></el-empty>
    <span class="intro-text">{{$t('cdnOrderList.renewal')}}：</span>
    <div class="radio-group-container">
      <el-radio
          v-for="(item) in renewalOptions"
          :key="item.id"
          v-model="purchaseFrom.radioRenewal"
          :label="item.id.toString()"
          border
          class="radio-item"
      >
        {{ item.name }}
      </el-radio>
    </div>
    <div>
      <el-card class="submit-from">
        <div class="form-row">
          <div class="form-item">
            <div style="font-size: 14px;">{{ $t('cdnOrderList.quantity') }}</div>
            <el-input-number
                v-model="purchaseFrom.num"
                @change="handleChange"
                :min="1"
                :max="100"
                label="描述文字"
            >
            </el-input-number>
          </div>
          <div class="form-item">
            <div style="font-size: 14px">{{ $t('cdnOrderList.time') }}</div>
            <el-select v-model="purchaseFrom.duration" :placeholder="$t('cdnOrderList.requireDuration')">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div>
            {{$t('cdnOrderList.price')}}{{selectedTrafficData ? (selectedTrafficData.price * purchaseFrom.num * purchaseFrom.duration) : 0}}¥
          </div>
          <div style="margin-left: auto;">
            <template>
              <el-popconfirm
                  :title="$t('cdnOrderList.confirmOrder')"
                  @confirm = "submitForm"

              >
                <el-button slot="reference" :loading="loading" >{{$t('cdnOrderList.submitOrder')}}</el-button>
              </el-popconfirm>
            </template>
          </div>
        </div>
      </el-card>

    </div>
  </div>
</template>

<script>

import common from '@/common/mixins/common.js';
import { mapState } from 'vuex';
export default {
  inject: ['layout', 'app'],
  mixins: [common],
  data(){
    return{
      loading : false,
      resourceData: [],
      allAccelerationData: [], // 保存所有加速区域数据
      filteredAccelerationData: [], // 根据资源类型过滤后的加速区域
      allTrafficData: [], // 保存所有流量包数据
      filteredTrafficData: [], // 根据加速区域过滤后的流量包
      renewalOptions: [
        { id: 0, name: '自动续费' },
        { id: 1, name: '手动续费' }
      ],
      purchaseFrom:{
        radioResource: '',
        radioAcceleration: '',
        radioTraffic: '',
        radioRenewal: '0',//默认自动续费
        num: '1',
        duration: '1'
      },
      options: [{
        value: '1', label: '一个月'
      },
        {
          value: '3', label: '三个月'
        },
        {
          value: '6', label: '六个月'
        },
        {
          value: '12', label: '一年'
        }
      ],
      selectedTraffic : ''
    }
  },
  watch: {
    refreshTrigger() {
      this.getList();    // 如果有其他需要刷新的方法
      this.layout.getPageNum();
    },
  },
  computed: {
    // 监听 Vuex state
    ...mapState(['refreshTrigger']), // 监听 Vuex state
    selectedTrafficData() {
      if (!this.purchaseFrom.radioTraffic) return null;
      return this.filteredTrafficData.find(item => item.id.toString() === this.purchaseFrom.radioTraffic);
    }
  },
  async created() {
    await this.resourceList()
    await this.accelerationList()
    await this.trafficList()

  },
  methods:{
    resourceList() {
      this.loading = true;
      this.axios.post('/admin/data/getEnabledResource', {}, {
        token: true,
      }).then(res => {
        let all = res.data;
        this.resourceData = all.data.list
        // 默认选择第一个
        if (this.resourceData.length > 0) {
          this.purchaseFrom.radioResource = this.resourceData[0].id.toString();
          this.handleResourceChange(this.purchaseFrom.radioResource);
        }
        this.loading = false;
      }).catch(error => {
        console.error(error);
        this.loading = false;
      });
    },
    accelerationList(){
      this.axios.post('/admin/data/getEnabledAcceleration',{},{
        token: true,
      }).then(res => {
        this.allAccelerationData = res.data.data.list
        // 根据初始选择的资源类型过滤
        if (this.purchaseFrom.radioResource) {
          this.handleResourceChange(this.purchaseFrom.radioResource);
        }
      }).catch(error => {
        console.error(error);
      });
    },
    trafficList(){
      this.loading = true
      this.axios.post('/admin/data/getEnabledTraffic',{},{
        token: true,
      }).then(res => {
        this.allTrafficData = res.data.data.list
        // 根据初始选择的加速区域过滤
        if (this.purchaseFrom.radioAcceleration) {
          this.handleAccelerationChange(this.purchaseFrom.radioAcceleration);
        }
        this.loading = false
      }).catch(error => {
        console.error(error);
        this.loading = false
      });
    },

    // 资源类型变化时处理
    handleResourceChange(resourceId) {
      if (!this.allAccelerationData || this.allAccelerationData.length === 0) {
        // 如果加速区域数据还没加载好，不执行过滤
        return;
      }
      // 过滤加速区域数据
      this.filteredAccelerationData = this.allAccelerationData.filter(
          item => item.resource_id.toString() === resourceId.toString()
      );

      // 重置后续选择
      this.purchaseFrom.radioAcceleration = '';
      this.purchaseFrom.radioTraffic = '';
      this.filteredTrafficData = [];

      // 默认选择第一个加速区域
      if (this.filteredAccelerationData.length > 0) {
        this.purchaseFrom.radioAcceleration = this.filteredAccelerationData[0].id.toString();
        this.handleAccelerationChange(this.purchaseFrom.radioAcceleration);
      }else {

        this.$message.warning('当前资源类型没有可用的加速区域');
        // 使用路由刷新而不是直接 reload，避免白屏
        setTimeout(() => {
          this.resourceList()
        }, 1000); // 给用户看到提示信息的时间

      }

    },

    // 加速区域变化时处理
    handleAccelerationChange(accelerationId) {
      if (!this.allTrafficData || this.allTrafficData.length === 0) {
        // 如果加速区域数据还没加载好，不执行过滤
        return;
      }
      // 过滤流量包数据
      this.filteredTrafficData = this.allTrafficData.filter(
          item => item.acceleration_id.toString() === accelerationId.toString()
      );

      // 重置后续选择
      this.purchaseFrom.radioTraffic = '';

      // 默认选择第一个流量包
      if (this.filteredTrafficData.length > 0) {
        this.purchaseFrom.radioTraffic = this.filteredTrafficData[0].id.toString();
      }else {
        this.$message.warning('当前加速区域没有可用的流量包');
        // 使用路由刷新而不是直接 reload，避免白屏
        setTimeout(() => {
          this.accelerationList()
        }, 1000); // 给用户看到提示信息的时间

      }
    },

    submitForm(){
      console.log('submitFrom')
      this.loading = true
      // 构建请求数据对象
      const orderData = {
        resource_id: parseInt(this.purchaseFrom.radioResource),
        acceleration_id: parseInt(this.purchaseFrom.radioAcceleration),
        traffic_id: parseInt(this.purchaseFrom.radioTraffic),
        renewal: parseInt(this.purchaseFrom.radioRenewal),
        quantity: this.purchaseFrom.num,
        duration: this.purchaseFrom.duration,
        price: (this.selectedTrafficData?.price ?? 0) * this.purchaseFrom.num * this.purchaseFrom.duration// 计算总价
      };
      this.axios.post('/admin/data/addOrder', orderData, {
        token: true,
      }).then(res => {
        console.log('submitFrom')
        console.log(res.data)
        const response = res.data;
        if (response.code === 1) {
          this.$message.success(response.msg);
          // 可以在这里重置表单或跳转到其他页面
        } else {
          this.$message.error(response.msg || '订单提交失败');
        }
      }).catch(error => {
        console.error(error);
        this.$message.error('网络错误，请稍后重试');
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.purchase{
  font-size: 14px;
  height: 1000px;
}
.radio-item {
  display: inline-block;
  width: 200px;
  margin-left: 10px;
  margin-bottom: 10px;
  vertical-align: top;
  font-size: 16px;

}
/* 介绍文字样式 */
.intro-text {
  font-size: 14px;
  line-height: 32px;
  margin-right: 10px;
  margin-left: 10px;
  white-space: nowrap;
}
.no-data {
  color: #999;
  font-size: 14px;
  margin-left: 10px;
  line-height: 32px;
}
.submit-from{
  margin-left: 10px;
  margin-top: 30px;
  height: 150px;
}
.form-row {
  display: flex;
  align-items: center;
  gap: 20px; /* 控制两个表单项之间的间距 */
}
/* 单独为这三个标题添加更醒目的样式 */
.section-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin: 20px 0 10px 10px;
  padding-bottom: 5px;
  display: inline-block; /* 使元素宽度由内容决定 */
  border-bottom: 2px solid #ff7940; /* 添加下划线 */
}
</style>